<!--  -->
<template>
  <div class="indentFooter">
    <div>
      <span class="title">订单编号</span>
      <span class="pice">{{orderDetail.orderNo}}
        <img src="@/assets/img/personalImg/copy.png" @click="orderCopy(orderDetail.orderNo)">
      </span>
    </div>
     <div>
      <span class="title">下单时间</span>
      <span class="pice">{{orderDetail.createTime}}</span>
    </div>
     <div v-if="orderDetail.payTime">
      <span class="title">付款时间</span>
      <span class="pice">{{orderDetail.payTime}}</span>
    </div>
     <div v-if="filterPaymentType(orderDetail.paymentType)&& orderDetail.orderAmount!=0 ">
      <span class="title">支付方式</span>
      <span class="pice">{{filterPaymentType(orderDetail.paymentType)}}</span>
    </div>
  </div>
</template>

<script>
import { copyTool } from '@/utils/tools';
import { paymentType } from '../../indentTools';

export default {
  props: {
    orderDetail: {
      type: Object,
    },
  },
  data() {
    return {
      orderNo: '',
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    orderCopy(orderNo) {
      copyTool(orderNo).then(() => {
        this.$toast('复制成功');
      }).catch(() => {
        this.$toast('复制失败');
      });
    },
    // 判断支付方式类型
    filterPaymentType(status) {
      return paymentType(status);
    },
  },
};

</script>
<style lang="scss" scoped>
.indentFooter{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 159px;
  margin-bottom: 122px;
  padding:33px 36px 0;
  background: $bgWhite;
  border-radius: 14px;
  div{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 38px;
    margin-bottom: 25px;
    .title{
      color: #333;
      font-weight: 500;
      font-size: 25px;
      line-height: 36px;
    }
    .pice{
      display: flex;
      align-items: center;
      color: #787878;
      font-size: 25px;
      line-height: 29px;
    }
    img{
      width: 43px;
      height: 43px;
    }
  }
}
</style>
